export const isDevelopment =
  process.env.REACT_APP_ENV_MODE === "dev" ||
  process.env.REACT_APP_ENV_MODE === "local";
